import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {SYMBOL} from "../enums/Enum";
import {SymbolContainer} from "../reels/SymbolContainer";
import {GameUtils} from "../utils/GameUtils";
import {NudgeSymbol} from "../reels/NudgeSymbol";
import {Sound} from "../sound/Sound";
import {IFinalEvaluatedArea} from "../server/Data";

export class NudgeStepRunner implements SimplePresentationRunner {
    shouldRun(): boolean {
        return Game.model.enhancerFeatures.indexOf(SYMBOL.X_NUDGE) > -1;
    }

    start(flowStateController: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => {
            flowStateController.setSkipCallback(() => {
                this.onSkip(tl);
            });
        });
        Game.model.enhancerFeatures.forEach((triggeredFeature: SYMBOL, index: number) => {
            if (triggeredFeature === SYMBOL.X_NUDGE) {
                const reelId: number = index + 1;
                tl.add(this.nudge(reelId))
            }
        });
        tl.add(() => {
            flowStateController.finish();
        })
    }

    private getSize(reelId: number, rowId: number): number {
        let size: number = 0;
        Game.model.gameData.finalEvaluatedArea[reelId][rowId].forEach((finalEvalArea: IFinalEvaluatedArea) => {
            size += finalEvalArea.size;
        });
        return size;
    }

    private nudge(reelId: number): gsap.core.Timeline {
        const duration: number = 0.3;
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        const rowId: number = reelId === 2 ? 3 : 2;
        const symbolContainer: SymbolContainer = GameUtils.getSymbol(reelId, rowId);
        const nudgeSym: NudgeSymbol = symbolContainer.symbols[0] as NudgeSymbol;
        let initialY: number = nudgeSym.y;

        //1st step
        let toRowId: number = rowId;
        const animName: string = reelId === 2 ? "active_nudge" : "active_nudge_half";
        const activeAnimName: string = reelId === 2 ? "active" : "active_half";
        tl.add(GameUtils.createTimelineForAnimation(nudgeSym, 0, animName, false), 0);
        tl.add(() => {
            Game.soundPlayer.playSound(Sound.X_NUDGE1);
        }, 0.3)

        tl.to(nudgeSym, {ease: "back.in(1.7)", duration: duration, y: initialY - (198 * 1)}, 0.3);
        tl.add(GameUtils.shake(0, 10, 100, 1, 0.1), ">");
        tl.add(() => {
            --toRowId;
            nudgeSym.updateMultiplier(this.getSize(reelId, toRowId));
        }, 0.4);

        //2nd step

        tl.add(GameUtils.createTimelineForAnimation(nudgeSym, 0, animName, false), 0.7);
        tl.add(() => {
            Game.soundPlayer.playSound(Sound.X_NUDGE2);
        }, 1);
        tl.to(nudgeSym, {ease: "back.in(1.7)", duration: duration, y: initialY - (198 * 2)}, 1);
        tl.add(GameUtils.shake(0, 15, 100, 1, 0.1), ">");
        tl.add(() => {
            --toRowId;
            nudgeSym.updateMultiplier(this.getSize(reelId, toRowId));
        }, 1.1);

        //3rd step
        if (reelId === 2) {
            tl.add(GameUtils.createTimelineForAnimation(nudgeSym, 0, animName, false), 1.4);
            tl.add(() => {
                Game.soundPlayer.playSound(Sound.X_NUDGE3);
            }, 1.7);
            tl.to(nudgeSym, {ease: "back.in(1.7)", duration: (duration * 0.5), y: initialY - (198 * 2.5)}, 1.7);
            tl.add(GameUtils.shake(0, 20, 100, 1, 0.1), ">");
            tl.add(() => {
                --toRowId;
                nudgeSym.updateMultiplier(this.getSize(reelId, toRowId));
            }, 1.8);
        }
        tl.add([
            GameUtils.createTimelineForAnimation(nudgeSym, 0, activeAnimName, false),
            () => {
                Game.reelView.reelModels[reelId].isNudgeReel = true;
            }]);
        return tl;
    }

    private onSkip(tl: gsap.core.Timeline) {
        tl.timeScale(10);
        tl.add(() => {
            Game.soundPlayer.stopSound(Sound.X_NUDGE1);
            Game.soundPlayer.stopSound(Sound.X_NUDGE2);
            Game.soundPlayer.stopSound(Sound.X_NUDGE3);
        })
    }

}